<template>
  <div>
    <PreviewFile v-if="isFilePreview" :type="'lessonChat'" class="z-10000" v-bind:file="filePreviewData"
      @closePopup="closePopup"></PreviewFile>
    <div :class="lightModeActive ? 'bg-verylightpink' : 'bg-lightmodePlayerbg'"
      class="min-w-64 d-flex flex-column align-items-center">
      <div class="flex-grow-1">
        <button class="mdc-icon-button study-drawer-toggler mgt-8 d-flex">
          <i class="material-icons t-color-whiteHigh mgt-0 font-26">
            format_list_bulleted
          </i>
        </button>
      </div>
      <div class="mgb-16  d-flex flex-column align-items-center">
        <i class="material-icons t-color-whiteHigh mgt-0 t-color-whiteHigh cursor-pointer font-26" tabindex="0">
          info
        </i>

        <div class="mgb-18 bg-whiteBorder w-full h-1 mgt-24"></div>

        <i :class="columViewSelected ? 't-color-whiteHigh' : 't-color-whiteDisabled'"
          class="material-icons  mgt-0  mgb-24 cursor-pointer font-26" tabindex="0" @click="columViewActive()"
          @keypress="columViewActive()">
          view_column
        </i>


        <i :class="!columViewSelected ? 't-color-whiteHigh' : 't-color-whiteDisabled'"
          class="material-icons  mgt-0  cursor-pointer font-26" tabindex="0" @click="columViewInActive()"
          @keypress="columViewInActive()">
          view_quilt
        </i>

        <div class="mgb-18 bg-whiteBorder w-full h-1 mgt-24"></div>
        <button @click="darkModeToLight()" @keypress="darkModeToLight()"><img
            :src="lightModeActive ? '/img/lightModeFixedButton.png' : '/img/darkModeFixedButton.svg'" alt=""
            class="cursor-pointer w-32 h-32"></button>
      </div>

      <div :class="lightModeActive ? 'bg-contentPlayerBgLight' : 'bg-contentPlayerBg'" class="study-drawer open">
        <div id="headHeading" :class="lightModeActive ? 'bg-documentGray ' : 'bg-contentPlayerBg'"
          class="d-flex justify-content-between align-items-start pdl-24 pdr-20 pdt-30 pdb-29">
          <div class="t-color-white">
            <div class="t-body1 t-color-whiteHigh font-m t-line-h-27">{{ $t('23') }}</div>
          </div>
          <button class="mdc-icon-button mgt--16 mgb--8 mgr--12" @click="closeChatRoom" @keypress="closeChatRoom">
            <i class="material-icons t-color-whiteHigh study-drawer-toggler-close">
              close
            </i>
          </button>
        </div>
        <div :class="lightModeActive ? 'bg-documentGray ' : 'bg-darkModePlayerBG'">
        </div>

        <div class="">
          <!-- Chat list starts -->
          <div id="chat" class="screen-height">
            <div class="position-relative d-flex flex-column h-full">
              <section id="chatContainer" class="pdb-16  media-chat-list">
                <ul>
                  <li v-if="staticChatData === false && listData && listData.length < 1">
                    <div class="chat-body other">
                      <div class="picture">
                        <img alt="" class="avatar" src="/images/admin_profile.png">
                      </div>
                      <div class="text">
                        <span class="t-body3">
                          Hi {{ userName }}, welcome!
                        </span>
                      </div>
                    </div>
                  </li>
                  <li v-for="(chat, index) in listData" :key="index" class="mgt-24">
                    <div
                      v-if="index === 0 || (index > 0 && ($moment(chat.created).format('YYMMDD') !== $moment(listData[index - 1].created).format('YYMMDD')))"
                      class="datetime">
                      <span class="t-helper font-r">
                        {{ $moment(chat.created).format('LL') }}
                      </span>
                    </div>
                    <div v-for="(attachment, index2) in chat.attachments" :key="index2" :class="{
                      'me': chat.owner,
                      'other': !chat.owner,
                      'with-avatar': index === 0 && !chat.owner,
                      'with-avatar': index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner,
                      'first': index > 0 && listData[index - 1].writer.id !== chat.writer.id,
                    }" class="chat-body">
                      <div v-if="!chat.owner" class="picture"
                        @click="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner) ? handleModal(chat, index) : null">
                        <!-- ADMIN? -->
                        <img
                          v-if="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)"
                          :src="chat.isBlocked ? '/images/avatar_image.png' : chat.writer.profile && chat.writer.profile.file.resourceUri && chat.writer.profile.file.resourceUri.length > 0 ? chat.writer.profile.file.resourceUri : '/images/avatar_image.png'"
                          alt="" class="avatar" />

                        <UserDetailActionModal v-if="modalOpen && index === selectedChild" :type="'CHAT'" :data="chat"
                          :selectedChild="selectedChild" @block="handleUserBlock"
                          className="opacity-1 chat-modal question-chat" />

                      </div>
                      <div v-if="!chat.isBlocked">
                        <img :class="{
                          'chat-attachment-left': chat.owner,
                          'chat-attachment-right': !chat.owner
                        }" :src="attachment.resourceUri" alt="" tabindex="0" @click="fileDisply(attachment)"
                          @kfeypress="fileDisply(attachment)">
                      </div>
                      <div v-else class="text chat-name">
                        <span class="t-body6 font-r l-spacing45 t-line-h-20">{{ $t("3814") }}</span>
                      </div>

                      <span class="t-helper time mgr-8">
                        {{ $moment(chat.created).format('LT') }}
                      </span>
                    </div>
                    <div v-if="chat.msg" :class="{
                      'me': chat.owner,
                      'other': !chat.owner,
                      'with-avatar': index === 0 && !chat.owner,
                      'with-avatar': index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner,
                      'first': index > 0 && listData[index - 1].writer.id !== chat.writer.id,
                    }" class="chat-body">
                      <div v-if="!chat.owner" class="picture"
                        @click="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner) ? handleModal(chat, index) : null">
                        <img
                          v-if="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)"
                          :src="chat.isBlocked ? '/images/avatar_image.png' : chat.writer.profile && chat.writer.profile.file.resourceUri && chat.writer.profile.file.resourceUri.length > 0 ? chat.writer.profile.file.resourceUri : '/images/avatar_image.png'"
                          alt="" class="avatar" />

                        <UserDetailActionModal v-if="modalOpen && index === selectedChild" :type="'CHAT'" :data="chat"
                          :selectedChild="selectedChild" @block="handleUserBlock"
                          className="opacity-1 chat-modal question-chat" />
                      </div>
                      <div
                        v-if="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)">
                        <div class="t-color-documentGray mgl-5 t-body3">
                          {{ $t("3437", { first: chat.writer.name.first, last: chat.writer.name.last }) }}
                        </div>
                        <div class="text chat-name">
                          <span class="t-body6 font-r l-spacing45 t-line-h-20 chat-name">
                            {{ chat.isBlocked ? $t("3814") : chat.msg ? chat.msg : 'No Message' }}
                          </span>
                        </div>
                      </div>

                      <div v-else class="text">
                        <span class="t-body6 font-r l-spacing45 t-line-h-20">
                          {{ chat.isBlocked ? $t("3814") : chat.msg ? chat.msg : 'No Message' }}
                        </span>
                      </div>
                      <span
                        v-if="index === 0 || (index > 0 && ($moment(chat.created).format('YYMMDD') === $moment(listData[index - 1].created).format('YYMMDD')))"
                        class="t-helper time mgr-8">{{ $moment(chat.created).format('LT') }}</span>
                    </div>
                  </li>
                </ul>
              </section>

              <infinite-loading direction="top" force-use-infinite-wrapper="#chatContainer" @infinite="fetchData">
                <div slot="no-more" class="t-color-white"></div>
                <div slot="no-results" class="t-color-white"></div>
                <div slot="spinner"></div>
              </infinite-loading>

              <section id="messageContainer2">
                <!-- <div class=" bg-whiteBorder w-full h-1"></div> -->
                <form novalidate="novalidate">
                  <div class="">
                    <div id="mentionContainer" style="display: none;">
                      <ul>
                        <li>Everyone</li>
                        <li>Teacher</li>
                        <li>Colleague</li>
                      </ul>
                    </div>
                    <div class="divider-white divider-subtabs w-full"></div>
                    <div class="text-row pdl-16 pdr-16 pdb-18" style="box-sizing: border-box;">
                      <textarea ref="msg" v-model="msg" :placeholder="$t('1203')"
                        class="cursor-blue comment_textarea mdc-text-field__input t-body3 font-r h-24 p-0 t-color-whiteHigh"
                        style="box-sizing: border-box;"></textarea>
                    </div>
                    <div v-if="attachments.length > 0" class="d-block w-full">
                      <div class="attachedFileContainer scroll-x">
                        <div v-for="(attachment, index) in attachments" :key="index" class="position-relative mgr-22">
                          <img :src="attachment.resourceUri" alt="Image" class="w-48 h-48" tabindex="0"
                            @click="fileDisply(attachment)" @keypress="fileDisply(attachment)">
                          <span class="remove-img remove-image-new position-absolute t-color-white"
                            @click="attachments.splice(index, 1)" @keypress="attachments.splice(index, 1)">
                            <img class="w-16 h-16" src="/img/close.svg">
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="btn-row  d-block">
                      <div class=" bg-whiteBorder w-full h-1"></div>
                      <div class="d-flex align-items-center justify-content-between pdt-4 pdb-3">
                        <ul>
                          <li>
                            <button id="btnPhoto" class="mdc-icon-button mdc-button min-w-48 mdc-ripple-upgraded"
                              type="button" @click="openFileUpload('uploadChatFile')"
                              @keypress="openFileUpload('uploadChatFile')">
                              <i :class="attachments.length > 0 ? 't-color-whiteHigh' : 't-color-whiteDisabled'"
                                class="material-icons">collections</i>
                              <input id="uploadChatFile" ref="imageFiles" :accept="allowImgExt()" class="d-none" multiple
                                type="file" @change="uploadChatFile()" />
                            </button>
                          </li>
                        </ul>
                        <button :class="isSendBtn ? 'mediasendButton' : 'mediasendButtonInactive'" :disabled="!isSendBtn"
                          class="mdc-icon-button  d-flex" type="button" @click="sendChat()" @keypress="sendChat()">
                          <i class="material-icons mgt-0">
                            arrow_upward
                          </i>
                        </button>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </form>
              </section>
            </div>
          </div>
          <div v-if="modalOpen" class="modal-background" @click="closeModal" />
          <!-- Chat list ends -->
        </div>
      </div>

      <div class="backdrop-study-drawer d-none"></div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import chatApi from '@/api/chatApi.js';
import { fileMixin } from '@/mixins/file.js';
import PreviewFile from "@/components/board/PerviewFile";
import { userMixin } from "@/mixins/user";
import UserDetailActionModal from "@/components/common/modal/UserDetailActionModal.vue";

export default {
  name: "LeftBarChat",

  props: ['lightModeActive'],

  data() {
    return {
      learnId: null,
      lessonId: null,
      roomId: null,

      examineeId: null,
      questionId: null,

      entered: false,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      showExamListChat: false,
      columViewSelected: false,

      mentionSelector: false,
      msg: '',
      attachments: [],
      isFilePreview: false,
      filePreviewData: null,
      staticChatData: true,
      userName: '',
      selectedChild: null,
      modalOpen: false,
    };
  },

  mixins: [fileMixin, userMixin],

  components: {
    InfiniteLoading,
    PreviewFile,
    UserDetailActionModal
  },

  computed: {
    isSendBtn() {
      return !!this.msg || !!this.attachments.length;
    },
  },

  updated() {
    this.isAttachments();
  },

  mounted() {
    this.userName = localStorage.getItem("memberName");
    if (this.listData && this.listData.listData > 0) {
      this.staticChatData = true
    } else {
      setTimeout(() => {
        this.staticChatData = false
      }, 2000);
    }
  },

  methods: {
    darkModeToLight() {
      this.$emit('darkModeToLight');
    },

    isAttachments() {
      return this.attachments.length
    },

    sendChat() {
      let params = {
        learnId: this.learnId,
        lessonId: this.lessonId,
        roomId: this.roomId > 0 ? this.roomId : null,
        msg: this.msg,
        attachments: this.attachments
      };

      chatApi.learnChatroomChat(params).then((response) => {
        this.msg = '';
        this.attachments = [];
        this.updateListData(response.data.data);
      }).catch((err) => {
        console.log(err);
      })
    },

    moveScrollBottom() {
      let element = this.$refs.scrollBottom
      let options = {
        container: '#chatContainer',
        easing: 'ease-in'
      }
      this.$scrollTo(element, 100, options)
    },

    // update chatting list data
    updateListData(data) {
      this.listData.push(data)
      this.roomId = data.roomId
      this.moveScrollBottom()
    },

    columViewInActive() {
      this.$emit('columViewActive', false);
      this.columViewSelected = false;
    },

    columViewActive() {
      this.$emit('columViewActive', true);
      this.columViewSelected = true;
    },

    setParamsLearn() {
      let params = {
        learnId: this.learnId,
        lessonId: this.lessonId,
        roomId: this.roomId,
        page: this.currentPage,
        size: 10,
        sort: 'id,desc'
      }
      return params;
    },

    fileDisply(data) {
      this.isFilePreview = true;
      this.filePreviewData = data;
    },

    closePopup() {
      this.isFilePreview = false;
    },

    fetchData($state) {
      this.learnId = this.$route.params.learnId;
      this.lessonId = this.$route.params.lessonId;

      let params = {
        learnId: this.learnId,
        lessonId: this.lessonId
      }

      // get chatting room information
      chatApi.learnChatroomLesson(params).then((response) => {
        this.entered = response.data.data.entered;
        this.roomId = response.data.data.id;
        if (response.data.data.entered) {

          params = this.setParamsLearn();

          if (this.totalPages >= this.currentPage) {
            chatApi.learnChatroomChatList(params).then((response) => {
              let responseData = response.data.data
              this.currentPage++
              this.totalPages = responseData.totalPages
              this.listData.unshift(...responseData.content.reverse());

              if (responseData.content.length) {
                $state.loaded()
              } else {
                $state.complete()
              }
              chatApi.learnChatroomChatRead(params).then((response) => { }).catch((err) => { })
            })
          } else {
            $state.complete()
          }

        } else {
          $state.complete()
        }

      }).catch((err) => { })
    },

    closeChatRoom() {
      this.$emit('setisQuestionAns')
    },
    handleModal(chat, idx) {
      this.modalOpen = !this.modalOpen;
      this.selectedChild = idx;
    },

    closeModal() {
      this.modalOpen = false;
      this.selectedChild = null;
    },

    async handleUserBlock(item, isBlocked) {
      await this.blockUser(item, isBlocked);
      window.location.reload();
    },
  }
}
</script>

<style scoped>
.z-10000 {
  z-index: 10000;
}

.chat-modal {
  z-index: 2 !important;
  top: auto !important;
  left: 10px !important;
  margin-top: -20px;
  margin-left: 20px;
  max-width: 40%;
}
</style>